import React, { useState } from "react";
import "./AgentRules.scss";

const FraudRules = () => {
  const allRules = [
    { id: "transaction_monitoring", name: "Transaction Monitoring" },
    {
      id: "customer_identification_program",
      name: "Customer Identification Program",
    },
    {
      id: "suspicious_activity_reporting",
      name: "Suspicious Activity Reporting",
    },
    {
      id: "currency_transaction_reporting",
      name: "Currency Transaction Reporting",
    },
  ];

  const [rules, setRules] = useState([
    { id: "transaction_monitoring", name: "Transaction Monitoring" },
  ]);
  const [selectedRuleId, setSelectedRuleId] = useState("");

  const handleAddRule = () => {
    const ruleToAdd = allRules.find((rule) => rule.id === selectedRuleId);
    if (ruleToAdd && !rules.find((rule) => rule.id === ruleToAdd.id)) {
      setRules([...rules, ruleToAdd]);
    }
  };

  const handleDeleteRule = (ruleId) => {
    setRules(rules.filter((rule) => rule.id !== ruleId));
  };

  const availableOptions = allRules.filter(
    (option) => !rules.find((rule) => rule.id === option.id)
  );

  return (
    <div className="agent-rules-container">
      <div>
        <div>
          <label for="time" class="selector-titles">
            Fraud Rule
          </label>
        </div>
        <div class="transaction-selector">
          <select
            value={selectedRuleId}
            onChange={(e) => setSelectedRuleId(e.target.value)}
          >
            <option value="">Select a Rule</option>
            {availableOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <button onClick={handleAddRule}>Fraud Rules</button>
        </div>
      </div>
      <table className="full-width-table-rules">
        <thead>
          <tr className="header-row">
            <th>Fee Plan</th>
            <th className="table-date-header">Status</th>
            <th className="table-date-header"> Action</th>
          </tr>
        </thead>
        <tbody>
          {rules.map((rule) => (
            <tr key={rule.id}>
              <td>{rule.name}</td>
              <td>
                <p className="enabled-rule">Enabled</p>
              </td>
              <td>
                <button onClick={() => handleDeleteRule(rule.id)}>
                  DELETE
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FraudRules;
